<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Deportistas alto rendimiento</span>
</mat-toolbar>

<div class="margin-container apearAnimation">
  <!-- <app-tableusr></app-tableusr> -->

  <div class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2">
    <mat-form-field appearance="outline" class="w-full md:w-auto">
      <mat-label>Nombre o Número de documento</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="searchString"
        (keyup.enter)="onEnter()"
      />
      <button
        *ngIf="searchString"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="searchString = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field
    appearance="outline" 
      class="example-full-width"
      style="padding-left: 10px; font-size: smaller"
    >
      <mat-label>Disciplina</mat-label>
      <mat-select
        [(ngModel)]="disciplinaSelect"
        (selectionChange)="cambioDiscipinaBuscar()"
      >
        <mat-option> Todas las disciplinas</mat-option>
        <mat-option
          *ngFor="let disciplinaTmp of lstDisciplinas"
          [value]="disciplinaTmp.id"
        >
          {{ disciplinaTmp.nombre }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="example-full-width" style="padding-left: 10px; font-size: smaller;">
        <mat-label>Club</mat-label>
        <mat-select [(ngModel)]="clubSelect" 
        (selectionChange)="cambioDiscipinaBuscar()"
        >
          <mat-option *ngFor="let clubTmp of lstClubes" [value]="clubTmp.id">
            {{clubTmp.nombre}}
          </mat-option>
        </mat-select>

      </mat-form-field>

  </div>

  <div class="loading-indicator" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
  </div>

  <mat-form-field appearance="outline" >
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element" class="txtMayuscula">
          {{ element.nombre }}
          <br />
          <small>{{ element.documento }}</small>
        </td>
      </ng-container>

      <ng-container matColumnDef="disciplina">
        <th mat-header-cell *matHeaderCellDef>Disciplina</th>
        <td mat-cell *matCellDef="let element">
          {{ element.disciplina }}
        </td>
      </ng-container>

      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef>Fecha actualización</th>
        <td mat-cell *matCellDef="let element">
          {{ element.fecha | date: "dd-MM-yyyy hh:mm a" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="club">
        <th mat-header-cell *matHeaderCellDef>Club</th>
        <td mat-cell *matCellDef="let element">
          {{ element.empresa }}
        </td>
      </ng-container>

      <ng-container matColumnDef="altoRendimiento">
        <th mat-header-cell *matHeaderCellDef>Alto rendimiento</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.altoRendimiento"> Alto rendimiento </span>
          <span *ngIf="!element.altoRendimiento"> En formación </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 100]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</div>
